import { isBlockRange, isTextRange } from '../constants';
import type {
    BlockRange,
    BlockRangeCreateProps,
    SelectionRange,
    TextRange,
    TextRangeCreateProps,
} from '../models';

export function isTextRangeSelection(selection: SelectionRange): selection is TextRange {
    return isTextRange(selection);
}

export function isBlockRangeSelection(selection: SelectionRange): selection is BlockRange {
    return isBlockRange(selection);
}

export function hasBlockRangeProperties(
    props: TextRangeCreateProps | BlockRangeCreateProps
): props is BlockRangeCreateProps {
    return 'anchorBlock' in props || 'focusBlock' in props;
}

export function isSwitchingSelection(
    current: SelectionRange,
    next: TextRangeCreateProps | BlockRangeCreateProps
) {
    return isBlockRange(current) !== hasBlockRangeProperties(next);
}
